import { Component, OnInit, OnChanges, ChangeDetectorRef, ViewChild } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router, RouterOutlet, ActivationStart } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OnScreenMessageService } from '../app/services/onScreenMessage/onScreenMessage.sevice';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnChanges {
  menuActive: boolean = true;
  resetMenu: boolean;
  staticMenuDesktopInactive: boolean = false;
  staticMenuMobileActive: boolean = true;
  activeMenuId: string;
  Language: string[];
  @ViewChild(RouterOutlet) outlet: RouterOutlet;

  notification: boolean = false;

  darkDemoStyle: HTMLStyleElement;
  constructor(public authService: AuthService, private router: Router, private onScreenMessageService: OnScreenMessageService, private translate: TranslateService, private cdRef: ChangeDetectorRef) {
    translate.setDefaultLang(localStorage.getItem('defaultLang'));
    this.Language = ["English", "French"];
  }

  ngOnInit() {
    this.router.events.subscribe(e => {
      if (e instanceof ActivationStart) {
        this.outlet.deactivate();
      }

    });
    this.translate.use(localStorage.getItem('defaultLang'))

  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  ngOnChanges() {
    this.translate.use(localStorage.getItem('defaultLang'))
  }

  isOverlay() {
    return false;
  }

  menuToggle() {
    this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive
    this.staticMenuMobileActive = !this.staticMenuMobileActive
  }

  onMenuButtonClick(event: Event) {
    this.menuActive = !this.menuActive;
    event.preventDefault();
  }
  menuToggleResponseView() {
    // this.staticMenuDesktopInactive = true
    // this.staticMenuMobileActive = true
  }


  closeNotification(event) {
    this.notification = false;
    event.preventDefault();
  }

  Userlogout() {

    this.authService.logout()
    localStorage.setItem('isAutenticatedUser', 'false');
    localStorage.setItem('defaultLang', 'fr');
    this.router.navigateByUrl('/');
    this.onScreenMessageService.Success(this.translate.instant('SCV.LOG.MSGSLOGOFF'))

  }

  activemenu() {
    this.staticMenuMobileActive = true
  }

}
